import { PipelineStatus, StageStatus } from '../../../core/modules/pipelines/pipelines.model';

export const BRENDA_GREEN = '#00B27B';

// ---------------------------------------------------------------------------
// Pipeline-level status (top of the card; current run state)
// ---------------------------------------------------------------------------

export const PIPELINE_STATUS_COLOR: Record<PipelineStatus, string> = {
  running: 'processing',
  pending: 'default',
  success: 'success',
  failed: 'error',
  cancelled: 'warning',
  warning: 'warning',
  unknown: 'default'
};

export const PIPELINE_STATUS_HEX: Record<PipelineStatus, string> = {
  running: '#1890ff',
  pending: '#bfbfbf',
  success: BRENDA_GREEN,
  failed: '#ff4d4f',
  cancelled: '#faad14',
  warning: '#faad14',
  unknown: '#bfbfbf'
};

export const PIPELINE_STATUS_LABEL: Record<PipelineStatus, string> = {
  running: 'Running',
  pending: 'Pending',
  success: 'Success',
  failed: 'Failed',
  cancelled: 'Cancelled',
  warning: 'Warning',
  unknown: 'Unknown'
};

// ---------------------------------------------------------------------------
// Stage-level status (steps within a run)
// ---------------------------------------------------------------------------

export const STAGE_STATUS_HEX: Record<StageStatus, string> = {
  'not-started': '#d9d9d9',
  running: '#1890ff',
  success: BRENDA_GREEN,
  failed: '#ff4d4f',
  skipped: '#d9d9d9'
};

export const STAGE_STATUS_LABEL: Record<StageStatus, string> = {
  'not-started': 'Pending',
  running: 'Running',
  success: 'Completed',
  failed: 'Failed',
  skipped: 'Skipped'
};

export const STAGE_TO_ANTD_STATUS: Record<StageStatus, 'wait' | 'process' | 'finish' | 'error'> = {
  'not-started': 'wait',
  running: 'process',
  success: 'finish',
  failed: 'error',
  skipped: 'wait'
};
